import React from "react"
import MuiButton, { ButtonProps } from "@material-ui/core/Button"
import { ErrorButton } from "./style"

type ButtonVariants = "error"

export type TButton = {
  className?: string
  variant?: ButtonProps["variant"] | ButtonVariants
}
export type TButtonProps<T = {}> = TButton & Omit<ButtonProps, "variant"> & T

export default function Button<T>({
  children,
  className,
  variant,
  size = "large",
  color = "secondary",
  disableRipple = true,
  disableElevation = true,
  ...buttonProps
}: TButtonProps<T>) {
  const commonProps: Partial<ButtonProps> = { className, disableRipple, disableElevation, size, color, ...buttonProps }

  if (variant === "error")
    return (
      <ErrorButton {...commonProps} color="default">
        {children}
      </ErrorButton>
    )
  return (
    <MuiButton {...commonProps} variant={variant}>
      {children}
    </MuiButton>
  )
}
